<template>
  <div>
    <div
      v-if="isLastChallenge"
      class="challenge-card last-challenge-card rounded bg-white flex"
    >
      <div
        :style="{ backgroundColor: sideCardBackgroundColor }"
        class="side-card p-2 rounded rounded-r-none flex flex-col justify-end items-center"
      >
        <img :src="sideCardIconUrl" width="20" alt="" />
        <span class="text-white text-xs">{{ sideCardText }}</span>
      </div>
      <div class="body-card px-4 py-2 flex-1 flex flex-col content-between">
        <h3 class="text-gray-500 font-light text-sm">
          Desafio <span class="font-normal ">Atual</span>
        </h3>
        <h2 class="text-2xl font-light leading-none flex-1">
          Desafio {{ challenge.number }}
        </h2>
        <!-- Disciplinas -->
        <div class="leading-none ">
          <span
            v-for="(discipline, index) in disciplines"
            :key="index"
            style="font-size:10px"
            class="text-xs text-gray-500 block leading-none "
          >
            <i
              class="material-icons font-bold"
              style="font-size:10px"
              :style="{ color: discipline.hex_color }"
            >
              done
            </i>
            {{ discipline.shortname }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LastChallengeCard",
  props: { challenge: Object, isLastChallenge: Boolean, status: String },

  computed: {
    disciplines: function() {
      if (this.challenge.lessons) {
        return this.challenge.lessons.map(lesson => {
          return lesson.discipline;
        });
      }
      return null;
    },
    sideCardText: function() {
      let text = "Novo!";
      if (this.status === "started") {
        text = "Iniciado";
      }
      if (this.status === "completed") {
        text = "Completo";
      }
      return text;
    },

    sideCardIconUrl: function() {
      let url = "/img/icons/baloon.svg";
      if (this.status === "started") {
        url = "/img/icons/clock.svg";
      }
      if (this.status === "completed") {
        url = "/img/icons/tick.svg";
      }
      return url;
    },

    sideCardBackgroundColor: function() {
      let color = "#9684B5";
      if (this.status === "started") {
        color = "#DDC982";
      }
      if (this.status === "completed") {
        color = "#99C884";
      }
      return color;
    }
  }
};
</script>

<style lang="scss" scoped>
.last-challenge-card {
  box-shadow: 0 0 0 0;
  box-shadow: 0px 20px 20px rgba(95, 77, 124, 0.05),
    // first layer shadow above
      0 15px 0 -5px #fff,
    // second layer above
      0px 20px 20px rgba(95, 77, 124, 0.15),
    // second layer shadow
      0 30px 0 -10px #fff,
    // third layer
      0px 20px 20px rgba(95, 77, 124, 0.15);

  margin-bottom: 40px;
  min-height: 120px;
}

//  The top layer shadow  0 1px 1px rgba(0, 0, 0, 0.15),
</style>
